<template>
  <el-dialog width="520px" title="备注"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="noteVisible">
    <div class="details">
      <el-form  ref="currencyForm"  size="small" v-loading="loading"   label-position="top"   label-width="100px"  :model="currencyForm"  :rules="currencyFormRules">
        <el-form-item prop="note" label="备注">
          <el-input type="textarea" v-model="currencyForm.note" placeholder="请输入备注" rows="4" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button  size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">提交</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { } from '@/api/api'
import {mapState} from "vuex";
import {licenseNote} from "../../../api/api";
export default {
  name: 'product_note',
  props: {
    noteVisible: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: Number,
      default: 0,
    },
    noteText: {
      type: String,
      default: '',
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      currencyForm:{
        note:''
      },
      currencyFormRules:{}
    }
  },

  created() {
    if(this.noteText){
      this.currencyForm.note = this.noteText
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {
    handleClickConfirm(){
      this.BtnDisabled = true
      let postData = {
        license_id:this.productId,
        note:this.currencyForm.note
      }
      licenseNote(postData).then(res => {
        if (res.code === 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.$emit('success')
              this.$emit('update:noteVisible', false)
              this.BtnDisabled = false
            }
          });
        }else{
          this.BtnDisabled = false
        }

      }).catch(() => {
        this.BtnDisabled = false
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:noteVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>

.details p{
  line-height: 22px;
  margin-bottom: 16px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
}
.details h5{
  line-height: 22px;
  margin-bottom: 16px;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
}
::v-deep .el-form--label-top .el-form-item__label{
  padding-bottom: 0;
}
</style>
